'use strict';

import {DSModel} from './dsmodel.js';

export class DS1Model extends DSModel
{
	obj_starting_date;
	obj_end_date;
	$filter;
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.$filter = $filter;
		this.setupItemData(itemData);
	}

	_getParams(){
		return ['summary', 'number', 'title', 'acronym', 'starting_date_type', 'starting_date_date', 'end_date_type', 'end_date_date', 'duration', 'consortium_agreement'];
	}
	
	_getFields(){
		return {
			a1_general_call_number: 'call_number',
			a1_general_call_title: 'call_title',
		};
	}

	afterSetup(data) {
		if(typeof(this.starting_date_date) !== 'undefined' && this.starting_date_date > 0){
			this.obj_starting_date = new Date(this.starting_date_date * 1000);
		}
		else{
			this.obj_starting_date = new Date();
		}
		this.makeCetField('obj_starting_date');
		this.obj_starting_date.setHours(12);

		if (typeof this.end_date_date !== 'undefined' && this.end_date_date > 0) {
			this.obj_end_date = new Date(this.end_date_date * 1000);
		} else {
			this.obj_end_date = new Date();
		}

		this.makeCetField('end_date_date');
		this.obj_end_date.setUTCHours(12);
		this.end_date_date = this.$filter('date')(this.obj_end_date, 'dd/MM/yyyy');
	}

}